// frontend/src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCJmNr2dapThES34r6Y5U-a9I5lEAPG7uM",
  authDomain: "imvelaphi-8153d.firebaseapp.com",
  projectId: "imvelaphi-8153d",
  storageBucket: "imvelaphi-8153d.firebasestorage.app",
  messagingSenderId: "111937279743",
  appId: "1:111937279743:web:d8d9447677f688ce09deca",
  measurementId: "G-QK2WYPVH82"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth and get a reference to the service
export const auth = getAuth(app);

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;